export default function getTimeZone() {
  const timezone = (new Date().getTimezoneOffset() * -1) / 60;
  return timezone;
}
